export { default } from './useTheme';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/styles/esm/useTheme/index.js
// module id = 276
// module chunks = 2